import { IReducerAction } from 'src/interfaces/redux';
export * from './playback.selectors';

export interface IPlaybackState {
  firstPlay: boolean;
  ready: boolean;
  canPlay: boolean;
  paused: boolean;
  timePercent: number;
  volumePercent: number;
  bufferIndicatorPercent: number;
  currentTime: number;
  duration: number;
  videoDimensions: {
    width: number;
    height: number;
  };
  hasNativeHLS: boolean;
  playbackRate: number;
  isCloseToLiveEdge: boolean;
  isMuted: boolean;
  isSeeking: boolean;
}

export const playbackInitialState: IPlaybackState = {
  firstPlay: false,
  ready: false,
  canPlay: false,
  paused: true,
  timePercent: 0,
  bufferIndicatorPercent: 0,
  videoDimensions: {
    width: 0,
    height: 0,
  },
  volumePercent: 100,
  currentTime: 0,
  duration: 0,
  hasNativeHLS: false,
  playbackRate: 1,
  isCloseToLiveEdge: false,
  isMuted: false,
  isSeeking: false,
};

export enum PlaybackActionTypes {
  READY = 'PLAYBACK/READY',
  CAN_PLAY = 'PLAYBACK/CAN_PLAY',
  SET_IS_SEEKING = 'PLAYBACK/SET_IS_SEEKING',
  SET_PAUSED = 'PLAYBACK/SET_PAUSED',
  UPDATE_TIME_PERCENT = 'PLAYBACK/UPDATE_TIME_PERCENT',
  UPDATE_BUFFER_INDICATOR_PERCENT = 'PLAYBACK/UPDATE_BUFFER_INDICATOR_PERCENT',
  SET_VOLUME = 'PLAYBACK/SET_VOLUME',
  UPDATE_CURRENT_TIME = 'PLAYBACK/UPDATE_CURRENT_TIME',
  UPDATE_DURATION = 'PLAYBACK/UPDATE_DURATION',
  SET_HAS_NATIVE_HLS = 'PLAYBACK/SET_HAS_NATIVE_HLS',
  SET_PLAYBACK_RATE = 'PLAYBACK/SET_PLAYBACK_RATE',
  SET_IS_CLOSE_TO_LIVE_EDGE = 'PLAYBACK/SET_IS_CLOSE_TO_LIVE_EDGE',
  SET_VIDEO_DIMENSIONS = 'PLAYBACK/SET_VIDEO_DIMENSIONS',
}

export type IPlaybackAction = IReducerAction<PlaybackActionTypes>;

export default function playbackReducer(state: IPlaybackState = playbackInitialState, action: IPlaybackAction) {
  switch (action.type) {
    case PlaybackActionTypes.READY:
      return { ...state, ready: true };
    case PlaybackActionTypes.CAN_PLAY:
      return { ...state, canPlay: true };
    case PlaybackActionTypes.SET_PAUSED:
      return { ...state, paused: action.payload, firstPlay: true };
    case PlaybackActionTypes.UPDATE_TIME_PERCENT:
      return { ...state, timePercent: action.payload };
    case PlaybackActionTypes.UPDATE_BUFFER_INDICATOR_PERCENT:
      return { ...state, bufferIndicatorPercent: action.payload };
    case PlaybackActionTypes.SET_VOLUME:
      const { volumePercent, isMuted } = action.payload;
      return { ...state, volumePercent, isMuted };
    case PlaybackActionTypes.UPDATE_CURRENT_TIME:
      return { ...state, currentTime: action.payload };
    case PlaybackActionTypes.UPDATE_DURATION:
      return { ...state, duration: action.payload };
    case PlaybackActionTypes.SET_HAS_NATIVE_HLS:
      return { ...state, hasNativeHLS: action.payload };
    case PlaybackActionTypes.SET_PLAYBACK_RATE:
      return { ...state, playbackRate: action.payload };
    case PlaybackActionTypes.SET_IS_CLOSE_TO_LIVE_EDGE:
      return { ...state, isCloseToLiveEdge: action.payload };
    case PlaybackActionTypes.SET_IS_SEEKING:
      return { ...state, isSeeking: action.payload };
    case PlaybackActionTypes.SET_VIDEO_DIMENSIONS:
      return { ...state, videoDimensions: action.payload };
    default:
      return state;
  }
}
